import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import KenLoader from "../../GlobalComponents/KenLoader";
import {
  getExpertise,
  getStaffAplicationDetails,
} from "../../Utils/apiService";
import { useStyles } from "./styles";

const ChooseExpertise = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<any>();
  const [selectedRole, setSelectedRole] = useState("");
  const [appliedRole, setAppliedRole] = useState<any>();
  const [submittedTitles, setSubmittedTitles] = useState<string[]>([]);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const contactId: any = localStorage.getItem("contact-id");

        const [expertiseRes, applicationRes] = await Promise.all([
          getExpertise(),
          getStaffAplicationDetails(contactId),
        ]);

        if (expertiseRes?.data?.success) {
          setRoles(expertiseRes.data.data);
          const completedForms = applicationRes.data.data
            .filter((app: any) => app.Application_Status__c === "Completed")
            .map((app: any) => app.Application_Form__r?.Form_Title__c);

          setSubmittedTitles(completedForms);
        }
        if (applicationRes.data?.success) {
          setAppliedRole(applicationRes.data?.data);
        }
      } catch (err) {
        console.error("Error in fetch:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {" "}
      {loading ? (
        <KenLoader />
      ) : (
        <Box component={"div"} sx={{ height: "100%", width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "space-between",
              height: "100%",
              width: "100%",
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box sx={{ pt: "28px" }}>
                <Typography className={classes.headerTitle}>
                  Select your key expertise
                </Typography>
              </Box>
              <Box sx={{ pt: "18px" }}>
                <Typography className={classes.headerDescription}>
                  Select your primary role.
                </Typography>
              </Box>

              <RadioGroup
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
                sx={{ width: "100%", mt: 3 }}
              >
                {roles?.length > 0 &&
                  roles?.map((role: any, index: number) => (
                    <Paper
                      key={index}
                      elevation={selectedRole === role.Form_Title__c ? 4 : 1}
                      sx={{
                        mb: 2,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "#121212",
                        color: "#fff",
                        borderRadius: "12px",
                        cursor: "pointer",
                        border:
                          selectedRole === role.Form_Title__c
                            ? "1px solid #373A45"
                            : "1px solid transparent",
                        "&:hover": {
                          border: "1px solid #373A45",
                        },
                      }}
                      onClick={() => {
                        if (submittedTitles.includes(role.Form_Title__c)) {
                          setShowWarning(true);
                          return;
                        }

                        setSelectedRole(role.Id);
                        navigate(`/${role.Form_Title__c}`, {
                          state: {
                            title: role.Form_Title__c,
                            expertiseId: role.Id,
                          },
                        });
                      }}
                    >
                      <Typography>{role.Form_Title__c}</Typography>
                      <Radio
                        value={role.Id}
                        checked={selectedRole === role.Id}
                        onChange={() => {}}
                        sx={{ color: "#373A45" }}
                      />
                    </Paper>
                  ))}
              </RadioGroup>
            </Box>
          </Box>
        </Box>
      )}
      <Dialog
        open={showWarning}
        onClose={() => setShowWarning(false)}
        PaperProps={{
          sx: {
            backgroundColor: "#16161C",
            color: "#fff",
            borderRadius: "12px",
            padding: 2,
            maxWidth: "350px",
          },
        }}
      >
        <DialogContent sx={{ color: "#fff", fontSize: "16px", mb: 2 }}>
          You have already applied for this role. Please choose a different role
          to continue.
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button
            variant="contained"
            onClick={() => setShowWarning(false)}
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              color: "#000",
              borderRadius: "30px",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChooseExpertise;
